<template>
    <div style="padding-top:8px;">
        <div class="row">

            <div class="col-md-18">
                <presentation-portrait
                    :clinic_id="clinic.id"
                    :portrait="portrait"
                    @upload="portraitUpload"
                    @change="portraitChange"
                />
            </div>

            <div class="col-md-1">

            </div>

            <div class="col-md-31">

              <div class="form-group">
                  <label for="p_name">Namn</label>
                  <input class="form-control" id="p_name" type="text" v-model="name" />
              </div>

              <div class="form-group">
                  <label for="p_presentation">Presentation ({{ presentation_length }}/180)</label>
                  <textarea class="form-control" id="p_presentation" v-model="presentation" maxlength="180" style="height: 150px;"></textarea>
              </div>

              <div class="form-group" v-if="clinic.product_area_ids.indexOf(1) !== -1">
                  <label for="p_booking_link_25">Bokningslänk 25 min</label>
                  <input class="form-control" id="p_booking_link_25" type="text" v-model="booking_link_25" />
              </div>

              <div class="form-group" v-if="clinic.product_area_ids.indexOf(1) !== -1">
                  <label for="p_booking_link_40">Bokningslänk 40 min</label>
                  <input class="form-control" id="p_booking_link_40" type="text" v-model="booking_link_40" />
              </div>

              <div class="form-group" v-if="clinic.product_area_ids.indexOf(1) !== -1">
                  <label for="p_booking_link_50">Bokningslänk 50 min</label>
                  <input class="form-control" id="p_booking_link_50" type="text" v-model="booking_link_50" />
              </div>

              <div class="form-group" v-if="clinic.product_area_ids.indexOf(2) !== -1">
                  <label for="p_booking_link_60">Bokningslänk 60 min</label>
                  <input class="form-control" id="p_booking_link_60" type="text" v-model="booking_link_60" />
              </div>

              <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="p_is_public" v-model="is_public">
                  <label class="form-check-label" for="p_is_public">Visa i klippkortet</label>
              </div>

            </div>

        </div>

        <div style="margin-top: 20px;">
                <button class="btn btn-danger" style="float:left;" @click="triggerDelete()" :disabled="deleter.submitted">Ta bort utövaren</button>

                <button class="btn btn-primary" style="float:right; margin-left:10px;" @click="patcherPatch" :disabled="patcher.submitted">Spara</button>
                <button class="btn btn-secondary" style="float:right;" @click="abort()">Avbryt</button>
                
        </div>
        <br clear="all">
        

    </div>
</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import deleter from '../../../../shared/mixins/deleter'

import presentationPortrait from './presentation-portrait.vue'

export default {

    mixins: [
        patcher,
        deleter
    ],

    components: { presentationPortrait },

    props: {
        clinic: {
            required: true
        },
        practitioner: {
            required: true
        }
    },

    data () {
        return {
            is_public: this.practitioner.is_public,
            name: this.practitioner.name,
            presentation: this.practitioner.presentation,
            booking_link_25: this.practitioner.booking_link_25,
            booking_link_40: this.practitioner.booking_link_40,
            booking_link_50: this.practitioner.booking_link_50,
            booking_link_60: this.practitioner.booking_link_60,
            portrait: this.practitioner.portrait
        }
    },

    computed: {
        patcherUrl () {
            return `/clinics/${this.clinic.id}/practitioners/${this.practitioner.id}`
        },
        deleterUrl () {
            return `/clinics/${this.clinic.id}/practitioners/${this.practitioner.id}`
        },
        patcherData () {
            return {
                is_public: this.is_public,
                name: this.name,
                presentation: this.presentation,
                booking_link_25: this.booking_link_25,
                booking_link_40: this.booking_link_40,
                booking_link_50: this.booking_link_50,
                booking_link_60: this.booking_link_60,
                portrait: this.portrait
            }
        },
        presentation_length () {
            if (!this.presentation) {
                return 0
            }
            return this.presentation.length
        }
    },

    methods: {
        triggerDelete () {
            if (!confirm('Är du säker?')) {
                return
            }
            this.deleterDelete()
        },
        deleterSuccess () {
            this.$emit('patched')
        },
        patcherSuccess () {
            this.$emit('patched')
        },
        abort () {
            this.$emit('abort')
        },
        portraitUpload (image) {
            this.portrait = image
        },
        portraitChange (coordinates) {
            this.portrait.crop_width = coordinates.width
            this.portrait.crop_height = coordinates.height
            this.portrait.crop_left = coordinates.left
            this.portrait.crop_top = coordinates.top
        }
    }

}
</script>
